require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/registrer/jsRegistrer.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/registrer/jsRegistrer.legacy.js
// module id = 748
// module chunks = 31